export default __webpack_public_path__ + "static/media/dentist-2264144_1920.95a9c511.jpg";